import { SharedModule } from "./shared/module/shared.module";
import { ToasterService } from "./shared/services/toaster.service";
import { AdminModule } from "./admin/admin.module";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TokenManager } from "@app/shared/services/token-manager.service";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HttpClientModule } from "@angular/common/http";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";

import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { AdminComponent } from "./admin/admin.component";
import { NotFoundComponent } from "./shared/component/not-found/not-found.component";
import { AuthModule } from "./auth/auth.module";
import { ToastrModule } from "ngx-toastr";
import { TokenInterceptor } from "@app/app.interceptor";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { ApiHandler } from "@app/shared/services/api-handler.service";
import { ManageDrawer } from "@app/shared/services/drawer.service";
import { NgIdleKeepaliveModule } from "@ng-idle/keepalive";

@NgModule({
  declarations: [AppComponent, NotFoundComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    AuthModule,
    FormsModule,
    ReactiveFormsModule,
    ToastrModule.forRoot(),
    SharedModule,
    NgbModule.forRoot(),
    NgIdleKeepaliveModule.forRoot()
  ],
  providers: [
    TokenManager,
    ToasterService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    ApiHandler,
    ManageDrawer
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts